'use client'

import { Button } from '@cocoonspace/ui/components/button'
import { useLingui } from '@lingui/react/macro'
import Link from 'next/link'

import { AppWrapper } from '~/components/app-wrapper'
import { ErrorMsg } from '~/components/error-msg'

export const Page = () => {
	const { t } = useLingui()

	return (
		<AppWrapper>
			<div className='flex min-h-[100vh] flex-col items-center justify-center gap-4'>
				<ErrorMsg message={t`La page recherchée n'existe pas.`}>
					<Button asChild>
						<Link href='/paris'>{t`Trouver un Cocoon`}</Link>
					</Button>
				</ErrorMsg>
			</div>
		</AppWrapper>
	)
}
